import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface ActivityDataItem {
  label: string;
  value: string | number | null | Date | undefined;
  alwaysDisplay?: boolean;
}

@Component({
  selector: 'crm-activity-data-grid',
  templateUrl: './activity-data-grid.component.html',
  styleUrls: ['./activity-data-grid.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class ActivityDataGridComponent {
  readonly dataItems = input.required<ActivityDataItem[]>();
  readonly dateFormat = input<string>('mediumDateShortTime');

  isDate(value: string | number | null | Date | undefined): boolean {
    return value instanceof Date;
  }
}
